import { getTestimonials } from '@/api/testimonialApi'
import { useAuthStore } from '@/stores/auth.store'
import type { Testimonial } from '@/types/testimonials'
import { ref, computed } from 'vue'

const loaded = ref(false)
const participantTestimonials = ref<Testimonial[] | []>([])
const organizerTestimonials = ref<Testimonial[] | []>([])
const exists = computed(
    () => participantTestimonials.value.length > 0 || organizerTestimonials.value.length > 0
)

let inFlight: Promise<void> | null = null

async function load(): Promise<void> {
    if (loaded.value) return
    if (inFlight) return inFlight

    inFlight = getTestimonials()
        .then((result) => {
            participantTestimonials.value = result.participantTestimonials?.data || []
            organizerTestimonials.value = result.organizerTestimonials?.data || []
            loaded.value = true
        })
        .catch(() => {
            participantTestimonials.value = []
            organizerTestimonials.value = []
        })
        .finally(() => {
            inFlight = null
        })

    return inFlight
}

export function useTestimonials() {
    const auth = useAuthStore()

    // Reviewer navigation is intentionally hidden and reviewers cannot access testimonial content.
    if (!auth.isReviewer) void load()

    return {
        testimonialsExist: exists,
        loaded: loaded,
        participantTestimonials: participantTestimonials,
        organizerTestimonials: organizerTestimonials,
    }
}
